var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 613.4 169.9",
    style: {
      enableBackground: "new 0 0 613.4 169.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4,33.5v129.4H19.7V33.5H1V6.1h67.1v27.4L49.4,33.5z M126.5,98h-13.7v64.9H83.1V6.1h29.6v63.6h13.7V6.1h29.6v156.9h-29.6 V98z M234.8,162.9h-59.9V6.1h59.3v27.4h-30.1v36.4h27.2v27.7h-27.2v37h30.7V162.9z M298.4,127.4V40.5c0-25.7,14.6-36.4,37.3-36.4 c23.5,0,37,10.5,37,34.4v32.7H342V41.4c0-8.1-1.3-11.1-6.5-11.1c-5,0-6.3,3.5-6.3,12.9v81.5c0,9.6,1.1,12.6,6.3,12.6 c5,0,6.3-3.1,6.5-11.3V93.4h30.9v35.1c-0.4,26.8-13.7,36.4-37.5,36.4C310.4,164.9,298.4,154,298.4,127.4L298.4,127.4z M388.8,162.9 v-28.1h13.1V34h-13.1V6.1h54.7V34h-12.8v100.9h12.8v28.1H388.8z M505.1,33.5v129.4h-29.6V33.5h-18.7V6.1h67.1v27.4L505.1,33.5z  M557.1,162.9v-56.2L533.6,6.1h29.8l8.3,43.1l0.9,15.7l1.1-15.7l8.5-43.1h29.6l-24.2,99.8v57.1H557.1z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.564ab58fe7e0786f3b51dcaf33869573.svg";
export { ForwardRef as ReactComponent };